"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var next_components_1 = require("@dotdev/next-components");
var Snippets = require("snippets");
var BlockImage = /** @class */ (function (_super) {
    __extends(BlockImage, _super);
    function BlockImage(props) {
        return _super.call(this, props) || this;
    }
    BlockImage.prototype.render = function () {
        var _a = this.props, href = _a.href, image = _a.image, hoverImage = _a.hoverImage, ratio = _a.ratio, className = _a.className, hover = _a.hover, title = _a.title;
        return (React.createElement("div", null,
            this.props.label && this.props.label.length > 0 ? (React.createElement("div", { className: "h-2-4 mb-1-6 text-center font-semibold text-arctic text-sm py-0-5 " + (this.props.label.toString().toLowerCase().includes("sale") || this.props.label.toString().toLowerCase().includes("save")
                    ? "bg-red"
                    : "bg-water-blue") }, this.props.label)) : (React.createElement("div", { className: "h-2-4 mb-1-6" }, "\u00A0")),
            React.createElement("div", { className: "block w-full relative justify-center overflow-hidden" + (className ? " " + className : "") },
                React.createElement("a", { href: href, className: "block", title: title },
                    React.createElement(Snippets.Image, { ratio: ratio || "16:9", src: image, className: "mx-0 md:mx-1-9 " + (hoverImage && hover ? "transition-fast visible opacity-100 md:invisible md:opacity-0" : "transition opacity-100 visible") }),
                    hoverImage ? (React.createElement(Snippets.Image, { ratio: "none", src: hoverImage, className: "mx-0 md:mx-1-9 absolute pin " + (hover ? "transition invisible md:visible md:opacity-100" : "transition-fast opacity-0 invisible") })) : null))));
    };
    BlockImage.contextType = next_components_1.ShopifyNext.Context;
    return BlockImage;
}(React.PureComponent));
exports.BlockImage = BlockImage;
